"use client";

import { ChevronDown } from "components/SVG";
import React from "react";

import { ToggleButton } from "components/SiteChrome/ToggleButton";
import type { MerchandisingCategory } from "@shared/graphql.types";
import { list, listItem, icon, container, separatorRight } from "./style.css";

type Props = {
  items: MerchandisingCategory[];
  moreMenu: MerchandisingCategory;
};

export const NavBar: React.FC<Props> = ({ items, moreMenu }) => {
  return (
    <div data-testid="nav-bar" className={container}>
      <ul className={list}>
        {items.map((item) => {
          return (
            <li key={item.id} className={separatorRight}>
              {item.items?.length ? (
                <ToggleButton
                  aria-controls="main-menu"
                  className={`${listItem}`}
                  track-click="NavBar"
                  aria-label={`open ${item.title} menu`}
                  onClick={() => {
                    // automatically expand the first category...
                    (
                      document.querySelector(
                        "#main-menu li.level_0 button"
                      ) as HTMLButtonElement
                    )?.setAttribute("aria-expanded", "true");

                    if (
                      document.querySelector(
                        `[aria-controls="more-menu"][aria-expanded=true]`
                      )
                    ) {
                      (
                        document.querySelector(
                          `#more-menu [aria-controls="more-menu"]`
                        ) as HTMLButtonElement
                      )?.click();
                    }
                  }}
                >
                  {item.title}

                  <ChevronDown className={icon} />
                </ToggleButton>
              ) : (
                <a
                  className={listItem}
                  href={item.href ?? undefined}
                  track-click="NavBar"
                >
                  {item.title}
                </a>
              )}
            </li>
          );
        })}
        {moreMenu.items?.map((item) => {
          return (
            <li key={item.id}>
              <ToggleButton
                aria-controls="more-menu"
                className={`${listItem}`}
                track-click="NavBar"
                aria-label={`open ${item.title} menu`}
                onClick={() => {
                  if (
                    document.querySelector(
                      `[aria-controls="main-menu"][aria-expanded=true]`
                    )
                  ) {
                    (
                      document.querySelector(
                        `#main-menu [aria-controls="main-menu"]`
                      ) as HTMLButtonElement
                    )?.click();
                  }
                }}
              >
                {item.title}

                <ChevronDown className={icon} />
              </ToggleButton>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
